import Weather from "./weather";

function App() {
  return (
    <div>
      <Weather />
    </div>
  );
}

export default App;
